import React from 'react';
import PropTypes from 'prop-types';
import { RichTextPropTypes } from '../../prop-types';
import RichTextBase from './base';

const SimpleRichText = (props) => <RichTextBase assembly={null} {...props} />;

SimpleRichText.propTypes = {
  richText: RichTextPropTypes,
  className: PropTypes.string,
  textRenderer: PropTypes.func,
  backgroundColor: PropTypes.oneOf(['white', 'grey']),
  padding: PropTypes.bool,
  linkData: PropTypes.object,
};

SimpleRichText.defaultProps = {
  backgroundColor: 'white',
};

export default SimpleRichText;
